<template>
  <div class="wrapper">
    <nav class="navbar">
      <div class="navbar-brand is-uppercase is-family-secondary">
        <router-link to="/" class="navbar-item">
          <strong>{{ shopName }}</strong>
        </router-link>
        <a
          class="navbar-burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="navbar-menu"
          @click="showMobileMenu = !showMobileMenu"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div
        class="navbar-menu"
        id="navbar-menu"
        v-bind:class="{ 'is-active': showMobileMenu }"
      >
        <div class="navbar-start"></div>
        <div class="navbar-end" v-if="isAuthenticated">
          <router-link to="/shops" class="navbar-item">
            <span class="material-symbols-outlined"> storefront</span>
          </router-link>
          <!-- <router-link to="/tables" class="navbar-item">
            <span class="material-symbols-outlined"> coffee</span>
          </router-link> -->
          <a
            href="https://csa.williambh.com"
            class="navbar-item"
            target="blank"
          >
            <span class="material-symbols-outlined"> settings</span>
          </a>
          <div class="navbar-item">
            <div class="buttons">
              <router-link
                v-if="!isAuthenticated"
                to="/log-in"
                class="button is-light"
              >
                <span class="material-symbols-outlined"> login</span>
                Ingresar
              </router-link>
              <button v-else @click="logout" class="button is-danger">
                <span class="material-symbols-outlined"> logout</span>
                Salir
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <section class="section p-4">
      <router-view />
    </section>

    <footer class="footer mt-4 is-dark">
      <div class="content has-text-centered">
        <p>
          <strong>Coffe Shop Admin</strong> by
          <a href="#"> William Bustamante Herrera</a>. Copyright
          <span class="material-symbols-outlined"> copyright</span> 2022.
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      showMobileMenu: false,
      shops: [],
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
    shopName() {
      // console.log(this.$store.getters.getShop);
      return this.$store.getters.getShop.name || "Coffee Shop Admin";
    },
  },
  beforeCreate() {
    this.$store.commit("initializeStore");
    const token = this.$store.state.token;
    if (token) {
      axios.defaults.headers.common["Authorization"] = "Token " + token;
    } else {
      axios.defaults.headers.common["Authorization"] = "";
    }
  },
  mounted() {
    this.shops = this.$store.state.shops;
    document.title = "Coffee Shop Admin";
  },
  methods: {
    logout() {
      this.$store.commit("removeToken");
      axios
        .post("/api/v1/logout/")
        .then(() => {
          axios.defaults.headers.common["Authorization"] = "";
        })
        .catch((error) => {
          // console.log(error);
          if (error.response) {
            this.errors = [];
            for (const property in error.response.data) {
              this.errors.push(`${property}: ${error.response.data[property]}`);
            }
          } else {
            this.errors.push("Algo salió mal! :{");
            // console.log(error);
          }
        });

      this.$router.push("/log-in");
    },
  },
};
</script>

<style lang="scss">
@import "../node_modules/bulma";
</style>
